enum IconSizeEnum {
  xs = '.5rem',
  sm = '.75rem',
  md = '1rem',
  lg = '1.5rem',
  xl = '1.75rem',
  xxl = '2rem',
}

export default IconSizeEnum;
